import { isNull } from "@utils/var.check";
import { RULE_CONDITION_TYPE } from "@modules/attempt/service/attempt.constant";

export default {
  computed: {
    sectionPrerequisitesAllComplete() {
      let completed = true;
      if (!this.sectionPrerequisiteList || this.sectionPrerequisiteList.length === 0) {
        return completed;
      }
      this.sectionPrerequisiteList.forEach((sectionPrerequisite) => {
        if (
          sectionPrerequisite.criterion !== RULE_CONDITION_TYPE.GAME_AWARD &&
          sectionPrerequisite.criterion !== RULE_CONDITION_TYPE.GAME_CHOICE &&
          sectionPrerequisite.criterion !== RULE_CONDITION_TYPE.LEVEL_UP &&
          sectionPrerequisite.criterion !== RULE_CONDITION_TYPE.QUIZ_RANK
        ) {
          let completionStatus = this.getSectionCompletionStatus(
            sectionPrerequisite.conditionTargetId,
          );
          if (isNull(completionStatus)) {
            completed = false;
            return;
          }
          if (!completionStatus.completed) {
            completed = false;
          }
        }
      });
      return completed;
    },
    sectionPrerequisiteList() {
      return this.sectionPrerequisite;
    },
    getSectionCompletionStatus() {
      return (sectionId) => {
        let section = this.sectionList.find((section) => {
          return section.id === sectionId;
        });
        return section.statusInfo;
      };
    },
    showPrerequisite() {
      return this.sectionPrerequisite.length > 0;
    },
    showActivityPrerequisite() {
      return this.activityPrerequisite.length > 0;
    },
  },
};
